"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const create_icon_1 = require("../utils/create-icon");
exports.MenuIcon = (0, create_icon_1.createIcon)({
    displayName: "Menu",
    path: ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsx)("rect", { fill: "currentColor", x: ".78", y: "5.46", width: "22.43", height: "1" }), (0, jsx_runtime_1.jsx)("rect", { fill: "currentColor", x: ".78", y: "11.46", width: "22.43", height: "1" }), (0, jsx_runtime_1.jsx)("rect", { fill: "currentColor", x: ".78", y: "17.54", width: "22.43", height: "1" })] })),
});
